import { Map, List } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { EmployeeMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_REPLACEABLE_EMPLOYEES: {
      if (error) return state;

      return state.set(
        action.groupId.toString(),
        List(payload.filter(Boolean)).map(EmployeeMapper.from),
      );
    }
    default:
      return state;
  }
};
